import routerOptions0 from "/usr/src/app/node_modules/.pnpm/nuxt@3.14.1592_@parcel+watcher@2.5.0_@types+node@22.10.2_eslint@8.57.1_ioredis@5.4.1_magicast_xbkzymk6izycllcza445pdgroq/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/usr/src/app/workspace/web/app/router.options.ts";
const configRouterOptions = {
  scrollBehaviorType: "smooth",
  hashMode: false
}
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}